var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VView',{staticClass:"contest-game",attrs:{"back-button-to":"/menu","header":"Poziom 3"}},[_c('div',{staticClass:"contest-game__wrapper"},[_c('VGame',{on:{"end":function($event){return _vm.onGameEnd($event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }